import React from 'react';
import { ShortParagraphContentModel } from 'src/api/models/ShortParagraph';
import Paragraph from 'src/elements/typography/paragraph';
import styled, { css } from 'styled-components';

interface DynamicParagraphContainerProps {
  maxWidth?: string;
}

const DynamicParagraphContainer = styled.div<DynamicParagraphContainerProps>`
  display: grid;
  justify-self: center;
  max-width: 650px;
  box-sizing: border-box;
  padding: 0 10px;
  margin-bottom: 2rem;

  ${({ maxWidth }) =>
    !maxWidth
      ? ''
      : css`
          max-width: ${maxWidth};
        `}
`;

export default function getDynamicShortParagraph(shortParagraphProps: ShortParagraphContentModel): React.ReactNode {
  return (
    <DynamicParagraphContainer maxWidth={shortParagraphProps.maximumWidth}>
      <Paragraph
        text={shortParagraphProps.text}
        size={shortParagraphProps.size ? `${shortParagraphProps.size}px` : '1.2rem'}
        weight={shortParagraphProps.weight ?? 'light'}
        color={shortParagraphProps.color}
        align={shortParagraphProps.textAlign ?? 'center'}
      />
    </DynamicParagraphContainer>
  );
}
